export default {
    app: {
        name: "Acuitus Ag",
        version: "2.1"
    },
    common: {
        APP_API_URL: 'https://farm-api01.prod02.acuitusag.network',
        PAGE_URL: "admin.html",
        MAP_API_KEY: 'AIzaSyA6O9icblGQ9LmtuuqdnveY_sL98lzHtk8'
    },
    mqtt: {
        BROKER_SOCKET_IP: '://prod02.acuitusag.network:32005',

        TOPIC_FORMAT: '/acuitusag.com/stream/version/1/id/#external_id#/name/#name#',
        IS_ENABLE: false
    },
    websocket: {
        SOCKET_URL: 'wss://farm-api01.prod02.acuitusag.network',
        IS_ENABLE: true
    },
    remotescalesocket: {
        SOCKET_URL: 'ws://localhost:4000',
        API_URL: 'http://localhost:4000'
    },
    oauth: {
        google: {
            CLIENT_ID: '108681312374-ag22nrtpqvh75vgahom3pit948bbr9rg.apps.googleusercontent.com'
        },
        microsoft: {
            CLIENT_ID: '5e9337c6-936c-4210-b95c-b70c8cf42eca',
            REDIRECT_URI: null,
            SCOPES: ['user.read'],
            PROMPT: "select_account"
        },
        apple: {
            CLIENT_ID: "network.acuitusagservice.auth",
            REDIRECT_URI: "https://web-fm.prod02.acuitusag.network/",
            SCOPES: "email name"
        }
    },
    chat: {
        DOMAIN: "xmpp.prod02.acuitusag.network",
        IS_ENABLE: true
    },
    storage: {
        FILE_UPLOAD_URL: "https://www.googleapis.com/upload/storage/v1/b/acuitusag-xmpp-qa/o?uploadType=multipart&name=",
        FILE_RETRIEVE_URL: "https://storage.googleapis.com/acuitusag-xmpp-qa/",
        POST_FILE_UPLOAD_URL: "https://www.googleapis.com/upload/storage/v1/b/acuitusag_user_feedbacks/o?uploadType=multipart&name=",
        POST_FILE_RETRIEVE_URL: "https://storage.googleapis.com/acuitusag_user_feedbacks/"
    }
}
